import { PAYMENT_METHODS } from "../endpoints";
import api from "../api";

export default {
    index() {
        return api.get(PAYMENT_METHODS);
    }
}